let envelop = process.env.NODE_ENV;

const env =
    envelop === "production"
        ? "pro"
        : envelop === "test"
            ? "test"
            : "dev";
export function initShence(params) {
    params.env = env
    window.initRecordSDK(params)
}